import styled from 'styled-components';

export const APP_BAR_FIXED_HEIGHT = 44;

export const FixedBarTheme = styled.section`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    background-color: ${({ theme }) => theme.colors.barColor};
    height: ${APP_BAR_FIXED_HEIGHT}px;

    @media (max-width: 1200px) {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
    }
`;
